module.exports = __webpack_public_path__ + "img/buck-mob-logo.fe2af5e8.svg";